import {HttpClient$} from '@raison/network-facade';
import {queryOptions, usePrefetchQuery, useQuery} from '@tanstack/react-query';
import {atom, useAtomValue} from 'jotai';
import {fetchCurrenciesInfo} from '../api/fetchCurrenciesInfo';
import {isOfCryptoType} from './Currency';
import {primaryCurrency$} from './primaryCurrencyAtom';

const currenciesInfoQueryOptions$ = atom(get => {
    const http = get(HttpClient$);
    const pc = get(primaryCurrency$);
    const {queryKey, queryFn} = queryOptions({
        queryKey: [`v1/currencies`, pc.code],
        queryFn: () => fetchCurrenciesInfo(http, pc.code),
    });
    return {queryKey, queryFn};
});

export function useCurrenciesInfoOptions() {
    return useAtomValue(currenciesInfoQueryOptions$);
}

export function useCryptoCurrenciesInfo() {
    return useQuery({
        ...useCurrenciesInfoOptions(),
        select: info => info.filter(isOfCryptoType),
    });
}

export function useCurrenciesInfoPrefetch() {
    usePrefetchQuery(useAtomValue(currenciesInfoQueryOptions$));
}
